module.exports = "/assets/data/7eaf36b9b142543e7088a8139962af94-DY4.data.json";